import {
    FooterSkeletonLoader,
    HeaderSkeletonLoader,
    PdfContainerSkeletonLoader,
} from "./layout";
import {
    StyledInsightSheetBody,
    StyledInsightSheetHeader,
    StyledSheetFooter,
    StyledDetailSheetPDFViewerContainer,
} from "./styles";

export const InsightDetailSheetSkeleton: React.FunctionComponent = () => {
    return (
        <div data-testid="insight-detail-sheet-skeleton-container">
            <StyledInsightSheetBody>
                <StyledInsightSheetHeader>
                    <HeaderSkeletonLoader />
                </StyledInsightSheetHeader>
                <StyledDetailSheetPDFViewerContainer>
                    <PdfContainerSkeletonLoader />
                </StyledDetailSheetPDFViewerContainer>
                <StyledSheetFooter>
                    <FooterSkeletonLoader />
                </StyledSheetFooter>
            </StyledInsightSheetBody>
        </div>
    );
};
